module.exports = __webpack_public_path__ + "static/bank-building-170eb03a6eff27667f43548a86f314fd.jpg";